const queryFunction = (
  query,
  fetchFunction,
  setIsError = () => {},
  id,
  log = false
) =>
  new Promise(async (resolve, reject) => {
    try {
      setIsError(false);
      const data = await fetchFunction(
        query.pageSize,
        query.page + 1,
        query.search ? `${query.search}` : null,
        query.orderBy?.field || null,
        query.orderDirection || null,
        id
      );

      log &&
        console.dir({
          data: data?.rows || [],
          page: data?.page - 1,
          totalCount: data?.total,
        });

      resolve({
        data: data?.rows || [],
        page: data?.page - 1,
        totalCount: data?.total,
      });
    } catch (error) {
      resolve({
        data: [],
        page: 0,
        totalCount: 0,
      });
      setIsError(true);
    }
  });

export default queryFunction;
